import { render, staticRenderFns } from "./AiTips.vue?vue&type=template&id=40e9bb1c&scoped=true&"
import script from "./AiTips.vue?vue&type=script&lang=js&"
export * from "./AiTips.vue?vue&type=script&lang=js&"
import style0 from "./AiTips.vue?vue&type=style&index=0&id=40e9bb1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e9bb1c",
  null
  
)

export default component.exports